type QA = { q: string; a: string };

const FAQS: QA[] = [
  {
    q: "Will AI ever stamp without my review?",
    a: "No. AI supervises, asks, flags, and learns. It never stamps and never carries the professional liability. A licensed engineer of record reviews the package and applies the stamp, and that gate doesn't move in any control mode. (Not every jurisdiction requires a stamp at all; where one isn't required, your plans typically go straight to permitting.)",
  },
  {
    q: "How is this not just another black box?",
    a: "Because the reasoning is in the open. Every load and member traces to a cited clause and edition; the full decision log records every question, assumption, and learned preference. The proprietary solver internals stay sealed; the trail you'd defend never does.",
  },
  {
    q: "Is the engine deterministic, or does it answer differently each run?",
    a: "The calc engine is deterministic and code-driven: the same plan and standards always produce the same result. AI sits on top to move fast and route the judgment calls to you; it doesn't invent the numbers.",
  },
  {
    q: "Which codes and editions does it follow?",
    a: "Loads use ASCE 7-22; wood members use NDS 2024, with wood lateral work based on SDPWS 2021 and building-code criteria from IBC / IRC 2024. The calculation workspace also includes bounded first-release checks for AISC 360-22 rolled W-shapes, AISI / SFIA cold-formed members, ACI 318-19(22) normalweight concrete beams and footings, and source-edition masonry walls and lintels. Every sheet prints its exact edition, applicability conditions, and excluded checks.",
  },
  {
    q: "What's live today vs. in development?",
    a: "Live now: the automated wood design pipeline, the NDS / SDPWS engine and sourced member database, ten load calculators, and bounded steel, cold-formed, concrete, masonry, proprietary-hardware, and section-property calculators. Broader shapes, systems, load cases, and newer source editions remain in development; aluminum stays withheld until its shape catalog and design basis are complete. A demo shows the live system and the same limitations users see on every calculation sheet.",
  },
  {
    q: "Will it fit our AutoCAD workflow?",
    a: "Yes. The engine's native drawing output is DXF, and the CLI can be called from anything that runs a command: an AutoLISP routine, an AutoCAD plugin, a batch script. Your existing automations call a run, and the layouts and calc packages come back into the environment you already use.",
  },
  {
    q: "Can you just do the engineering for us?",
    a: "Yes. Firmark is run by engineers, and some firms prefer to send work rather than learn software. Start the intake with your PDF or DWG; a licensed engineer runs it through the same pipeline and hands back a stamp-ready plan set and calc package, typically in one to two days.",
  },
  {
    q: "What does it cost?",
    a: "The models are in the pricing section above: per stamped lot for builders, per engineer seat for firms, and per plan set if you send us the work. What beta changes is the number: we set the actual rate with you against your volume, and beta partners keep their founding rate after launch. Book a demo and we'll talk real numbers.",
  },
];

export function Faq() {
  return (
    <section className="landing-wrap landing-section" id="faq">
      <div className="section-head">
        <h2 className="section-title">The questions engineers ask first.</h2>
      </div>

      <div className="faq">
        {FAQS.map((f) => (
          <details className="faq-item" key={f.q}>
            <summary>
              <span>{f.q}</span>
              <span className="faq-icon" aria-hidden="true">+</span>
            </summary>
            <p>{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
